<template>
    <div class="form-item">
        <label class="label-caption">Departamento</label>
        <select :value="departamentoSelecionado" @change="atualizarObj" class="form-control" v-bind="$attrs"> 
            <option v-if="isLoading" disabled>Carregando...</option>
            <option v-if="!lsDados || lsDados.length === 0" disabled>Nenhuma opção disponível</option>
            <option v-for="obj in lsDados" :key="obj.id" :value="obj.id">{{ obj.nmdepartamento }}</option>
        </select>
    </div>
</template>

<script setup>
import { ref, watch, onMounted } from "vue";
import { genericPost } from "@/funcoes/api";
import { globalStore } from "@/globals";

const props = defineProps({
    ckAddTodos:{type: Boolean, default: false},
    ckPesquisar: {type: Boolean, default: true},
    setFirst: {type: Boolean, default: false},
    departamentoSelecionado: {type: Number, default: null,},
});

const emit = defineEmits(["update:departamentoSelecionado"]);

const lsDados = ref(null);
const isLoading = ref(false);

const fetchData = async () => {
    try {
        isLoading.value=true;
        const response = await genericPost('/listas/gabinete_departamentos', {idmunicipio: globalStore.idmunicipio, ativo: 'S'});
        lsDados.value = response;
        if (lsDados.value.length>0 && props.setFirst) emit("update:departamentoSelecionado", Number(lsDados.value[0].id));
        if (props.ckAddTodos){lsDados.value.unshift({ id: 0, nmdepartamento: 'TODOS' });}
    } catch (error) {console.error("Erro de conexão com a API:", error);
    }finally{isLoading.value=false;} 
};

const atualizarObj = (event) => {
    emit("update:departamentoSelecionado", Number(event.target.value));
};

onMounted(() => {
    if (props.ckPesquisar){
        fetchData();
    }
});

watch(
    () => props.ckPesquisar,
    (newValue, oldValue) => {
        if (newValue && !oldValue) {fetchData();}
    }
);
</script>
  